<template>
  <div>
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity="1"
      rounded="sm"
      :show="loadingDriverWallet"
    >
      <b-row v-if="!loadingDriverWallet">
        <b-col md="12">
          <sticky-driver-data
            viewd-in="driver-wallet"
            @refetch-driver-wallet="$emit('refetch-driver-wallet')"
          />
        </b-col>
        <b-col
          md="12"
        >
          <e-wallet
            v-if="driverWalletData.eWallet && driverWalletData.eWallet.length > 0"
            :driver-wallet="driverWalletData"
            @show-edit-section="showEditSection = true"
          />
        </b-col>
        <b-col
          v-if="$can('read', 'driver-wallet-transactions') "
          md="6"
        >
          <driver-balance-statistics
            v-if="driverWalletData"
            :balance-statistics="driverWalletData.statistics.balance"
          />
        </b-col>
        <b-col
          v-if="$can('read', 'driver-wallet-transactions') "
          md="6"
        >
          <driver-pending-balance-statistics
            v-if="driverWalletData"
            :pending-balance-statistics="driverWalletData.statistics.pendingBalance"
          />
        </b-col>

        <b-col md="12">
          <FirstAndOneTimeTransaction @added="$emit('refetch-driver-wallet')" />
        </b-col>

        <!-- Start Transactions List -->
        <b-col
          v-if="$can('read', 'driver-wallet-transactions') "
          md="12"
        >
          <driver-transactions
            @reversed="$emit('reversed')"
            @refetch-driver-wallet="$emit('refetch-driver-wallet')"
            @refetch-driver-inactivations="$emit('refetch-driver-inactivations')"
          />
        </b-col>
        <!-- End Transactions List -->

        <b-col
          v-if="$can('read', 'driver-wallet-transactions') "
          md="12"
        >
          <driver-pending-transactions @refetch-driver-wallet="$emit('refetch-driver-wallet')" />
        </b-col>

        <b-col
          v-if="$can('read', 'driver-wallet-settings') "
          :md="showEditSection ? '8' : '12'"
        >
          <wallet
            v-if="driverWalletData"
            :driver-wallet="driverWalletData"
            @show-edit-section="showEditSection = true"
          />
        </b-col>
        <b-col
          v-if="$can('read', 'driver-wallet-settings') && $can('write', 'driver-wallet-settings')"
          md="4"
        >
          <edit-driver-wallet
            v-if="showEditSection"
            :driver-wallet="driverWalletData"
            @hide-edit-section="showEditSection = false"
            @refetch-driver-wallet="$emit('refetch-driver-wallet')"
          />
        </b-col>
      </b-row>
    </b-overlay>
  </div>
</template>

<script>
import {
  BRow, BCol, BOverlay,
} from 'bootstrap-vue'

import { ref } from '@vue/composition-api'

import StickyDriverData from '../../StickyDriverData.vue'
import Wallet from './Wallet.vue'
import EditDriverWallet from './EditDriverWallet.vue'
import DriverBalanceStatistics from './DriverBalanceStatistics.vue'
import DriverPendingBalanceStatistics from './DriverPendingBalanceStatistics.vue'
import DriverTransactions from './DriverTransactions.vue'
import DriverPendingTransactions from './DriverPendingTransactions.vue'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import billingStore from '@/views/billing/billingStore'
import EWallet from './EWallet.vue'
import FirstAndOneTimeTransaction from './FirstAndOneTimeTransaction.vue'

export default {
  components: {
    BRow,
    FirstAndOneTimeTransaction,
    BCol,
    BOverlay,
    StickyDriverData,
    Wallet,
    EditDriverWallet,
    DriverBalanceStatistics,
    DriverPendingBalanceStatistics,
    DriverTransactions,
    DriverPendingTransactions,
    EWallet,
  },
  props: {
    loadingDriverWallet: {
      type: Boolean,
      default: false,
    },
    driverWalletData: {
      type: Object,
      default: () => {},
    },
  },
  setup() {
    useRegisterStoreModule('billing', billingStore)
    const showEditSection = ref(false)

    return {
      showEditSection,
    }
  },
}
</script>
